import { render, staticRenderFns } from "./CommonScreenTop.vue?vue&type=template&id=1920c17a&"
import script from "./CommonScreenTop.vue?vue&type=script&lang=ts&"
export * from "./CommonScreenTop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports